import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Privacy from '../views/Privacy.vue'
import Cookies from '../views/Cookies.vue'
import Services from '../views/Services.vue'
import IBD from '../views/IBD.vue'
import IU from '../views/IU.vue'
import ICH from '../views/ICH.vue'
import DS from '../views/DS.vue'
import AD from '../views/AD.vue'
import WO from '../views/WO.vue'
import LandingMta from '../views/landings/Mta.vue'
import LandingCovid from '../views/landings/Covid-19.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	// {
	//   path: '/about',
	//   name: 'About',
	//   // route level code-splitting
	//   // this generates a separate chunk (about.[hash].js) for this route
	//   // which is lazy-loaded when the route is visited.
	//   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	// },
	{
		path: '/servicios',
		name: 'Services',
		component: Services
	},
	{
		path: '/innovacion-basada-en-datos',
		name: 'IBD',
		component: IBD
	},
	{
		path: '/investigacion-de-usuarios',
		name: 'IU',
		component: IU
	},
	{
		path: '/innovacion-en-capital-humano',
		name: 'ICH',
		component: ICH
	},
	{
		path: '/diseno-de-servicios',
		name: 'DS',
		component: DS
	},
	{
		path: '/arquitectura-de-decisiones',
		name: 'AD',
		component: AD
	},
	{
		path: '/workshops-para-organizaciones',
		name: 'WO',
		component: WO
	},
	{
		path: '/privacidad',
		name: 'Privacy',
		component: Privacy
	},
	{
		path: '/cookies',
		name: 'Cookies',
		component: Cookies
	},
	{
		path: '/covid-19',
		name: 'LandingCovid',
		component: LandingCovid
	},
	{
		path: '/mta',
		name: 'LandingMta',
		component: LandingMta
	},
	{
		path: '*',
		component: Home
	}
]

const router = new VueRouter({
	routes: routes,
	mode: 'history',
	transitionOnLoad: true,
	hash: false,
})

export default router